import '@fontsource/dancing-script/400.css'

export const SIGNATURE_FONT = "'Dancing Script', cursive"
export const INK = '#14213D'
const MAX_PNG_BYTES = 200 * 1024

export async function ensureSignatureFont(): Promise<void> {
  try {
    await document.fonts?.load(`400 64px ${SIGNATURE_FONT}`)
  } catch {
    // Falls back to the browser's cursive face.
  }
}

export function canvasToPng(canvas: HTMLCanvasElement): string {
  const b64 = canvas.toDataURL('image/png').replace(/^data:image\/png;base64,/, '')
  if (b64.length * 0.75 > MAX_PNG_BYTES) throw new Error('The signature image is too large. Clear it and try again.')
  return b64
}

/** The typed name drawn in the cursive face: transparent background, dark ink, base64 PNG. */
export async function typedToPng(text: string, height = 120, maxWidth = 900): Promise<string> {
  await ensureSignatureFont()
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('Your browser cannot create a signature image.')
  const pad = Math.round(height * 0.15)
  let size = Math.round(height * 0.6)
  ctx.font = `${size}px ${SIGNATURE_FONT}`
  let w = ctx.measureText(text).width
  if (w + pad * 2 > maxWidth) {
    size = Math.floor(size * (maxWidth - pad * 2) / w)
    ctx.font = `${size}px ${SIGNATURE_FONT}`
    w = ctx.measureText(text).width
  }
  canvas.width = Math.max(1, Math.ceil(w + pad * 2))
  canvas.height = height
  // Resizing a canvas resets its context state.
  ctx.font = `${size}px ${SIGNATURE_FONT}`
  ctx.fillStyle = INK
  ctx.textBaseline = 'middle'
  ctx.fillText(text, pad, height / 2)
  return canvasToPng(canvas)
}

export function initialsFrom(name: string): string {
  return name.trim().split(/\s+/).filter(Boolean).map(p => p[0]!.toUpperCase()).join('').slice(0, 4)
}

export const pngSrc = (b64: string) => `data:image/png;base64,${b64}`
